/**
 * Unregisters all service workers and deletes Cache Storage entries.
 * Used by SW migration, deploy version recovery, and chunk-load recovery.
 */
export const clearServiceWorkerAndCaches = async (): Promise<void> => {
  if (typeof window === 'undefined') {
    return;
  }

  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map(registration => registration.unregister()));
  }

  if (typeof caches !== 'undefined' && caches) {
    const cacheKeys = await caches.keys();
    await Promise.all(cacheKeys.map(cacheKey => caches.delete(cacheKey)));
  }
};
